var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useMemo, useState } from 'react';
import { Button, Popconfirm, theme } from '@robinpowered/ui-kit';
import { ComposerMode } from '../../../types/index';
import { useTranslation } from 'react-i18next';
import { useEventComposerGlobalContext } from '../../../composers/EventComposerGlobalContext';
import { COMPOSER_DRAWER_WIDTH } from '../../../constants/drawerSizes';
var actionButtonStyle = {
    width: '100%',
    alignSelf: 'flex-start',
};
export var useSpaceActions = function (_a) {
    var initialSpaceIds = _a.initialSpaceIds, spaceId = _a.spaceId, spaceInviteeId = _a.spaceInviteeId, onChangeSpace = _a.onChangeSpace, userCanRemoveSpace = _a.userCanRemoveSpace;
    var tSpaceBooking = useTranslation('spaceBooking').t;
    var token = theme.useToken().token;
    var _b = useEventComposerGlobalContext(), composerMode = _b.composerMode, pendingSpaceSwap = _b.pendingSpaceSwap, removeSpace = _b.removeSpace;
    var showPopconfirm = composerMode === ComposerMode.EDIT &&
        (initialSpaceIds === null || initialSpaceIds === void 0 ? void 0 : initialSpaceIds.includes(spaceId.toString()));
    var isSpaceChangePending = (pendingSpaceSwap === null || pendingSpaceSwap === void 0 ? void 0 : pendingSpaceSwap.spaceId) === spaceId;
    var _c = __read(useState(false), 2), isRemovingSpace = _c[0], setIsRemovingSpace = _c[1];
    var onRemoveSpace = useCallback(function (spaceId, spaceInviteeId) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsRemovingSpace(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, removeSpace(spaceId, spaceInviteeId)];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    setIsRemovingSpace(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [removeSpace]);
    return useMemo(function () {
        if (!userCanRemoveSpace)
            return [];
        var changeAction = (_jsx(Button, { variant: "outlined", type: "text", size: "small", onClick: function () {
                if (!showPopconfirm) {
                    onChangeSpace(spaceId, spaceInviteeId);
                }
            }, style: actionButtonStyle, disabled: !!isSpaceChangePending, loading: isSpaceChangePending, children: isSpaceChangePending
                ? tSpaceBooking('change_space.changing_space')
                : tSpaceBooking('change_space.action') }, "change"));
        var actions = [
            showPopconfirm ? (_jsx(Popconfirm, { title: tSpaceBooking('change_space.title'), description: tSpaceBooking('change_space.description'), styles: { root: { maxWidth: COMPOSER_DRAWER_WIDTH } }, onConfirm: function () { return onChangeSpace(spaceId, spaceInviteeId); }, children: changeAction }, "change-popconfirm")) : (changeAction),
        ];
        var removeAction = (_jsx(Button, { variant: "outlined", type: "text", size: "small", onClick: function () {
                if (!showPopconfirm) {
                    onRemoveSpace(spaceId, spaceInviteeId);
                }
            }, style: __assign(__assign({}, actionButtonStyle), { color: token.colorError }), disabled: !!isRemovingSpace, loading: isRemovingSpace, children: isRemovingSpace
                ? tSpaceBooking('remove_space.removing_space')
                : tSpaceBooking('remove_space.action') }, "remove"));
        actions.push(showPopconfirm ? (_jsx(Popconfirm, { title: tSpaceBooking('remove_space.title'), description: tSpaceBooking('remove_space.description'), styles: { root: { maxWidth: COMPOSER_DRAWER_WIDTH } }, onConfirm: function () { return onRemoveSpace(spaceId, spaceInviteeId); }, children: removeAction }, "remove-popconfirm")) : (removeAction));
        return actions;
    }, [
        isRemovingSpace,
        isSpaceChangePending,
        onChangeSpace,
        onRemoveSpace,
        showPopconfirm,
        spaceId,
        spaceInviteeId,
        tSpaceBooking,
        token.colorError,
        userCanRemoveSpace,
    ]);
};
